// extracted by mini-css-extract-plugin
export default {"TableHeader":"TableHeader1WTRHTbd9UKT"};